<div class="layout-section bg-[#EFF0F3]">
  <div class="w-full bg-red-1">
    <div
      class="py-1 max-w-[1600px] mx-auto text-sm text-center text-white sm:text-left text-11 sm:text-14 side-padding"
    >
      Resultados de fútbol en vivo - Marcadores247
    </div>
  </div>
  <app-tab-bar
    class="block 2xl:hidden"
    filtersOptions="header"
    [selectedIndex]="selectedIndex"
    (selectedIndexChange)="menuSelected($event)"
  />

  <app-pre-render-header />

  <div
    class="flex max-w-[1600px] mx-auto gap-4 side-padding max-sm:px-0 py-7 max-sm:py-3"
  >
    <app-pre-render-left-menu
      class="hidden w-full max-w-319 lg:block"
      [isfloating]="true"
    />

    <div class="block w-full gap-4 2xl:flex">
      <div class="w-full content-container">
        <!-- <app-skeleton-banner [isHorizontal]="true" /> -->

        <!-- <router-outlet></router-outlet> -->

        <app-pre-render-home />

        <div class="my-3">
          <!-- <app-skeleton-banner
            [isHorizontal]="true"
            [bannerSize]="secondSizeBanner"
          /> -->
          <!-- Case banner not loading -->
        </div>
      </div>
      <div class="hidden w-full side-padding sm:px-0 2xl:block max-w-319">
        <app-pre-render-right-menu />
        <!-- <app-right-menu></app-right-menu> -->
      </div>
    </div>
  </div>

  <app-pre-render-footer />
</div>
